module.exports = __webpack_public_path__ + "img/627-42dfb3.png";